import React, { useEffect, useState } from "react";
import "./App.css";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Header from "./components/header";
import Footer from "./components/footer";
import Login from "./pages/login";
import SearchPage from "./pages/searchPage";
import SearchDetails from "./pages/searchDetails";
import WriteReview from "./pages/review/writeReview";
import GlobalStyles from './assests/global-style/globalStyle';
import SignUp from "./pages/signUp";
import DonateNowPage from "./pages/donateNowPage";
import InviteReviews from "./pages/forNonprofits/reviews/invite";
import TopRatedAward from "./pages/topRated/awards";
import Guides from "./pages/topRated/guides";
import TopCities from "./pages/cities";
import TopCauses from "./pages/causes";
import GetStarted from "./pages/forNonprofits/getStarted";
import GreatNonprofitsBadge from "./pages/forNonprofits/greatNonprofitsBadge";
import Donations from "./pages/forNonprofits/donations";
import SuccessStories from "./pages/forNonprofits/successStories";
import ElliottAdvocacy from "./pages/forNonprofits/elliottAdvocacy";
import LadyFreethinker from "./pages/forNonprofits/ladyFreethinker";
import PartnerSolutions from "./pages/partnerSolutions";
import GreatNonprofitsApi from "./pages/solutions/api";
import DonateToNonprofits from "./pages/getInvolved/donateToNonprofits";
import LinkToUs from "./pages/getInvolved/linkToUs";
import Advertising from "./pages/getInvolved/Advertising";
import AboutGreatNonprofit from "./pages/aboutUs/aboutGreatNonprofit";
import Members from "./pages/aboutUs/members";
import OurStory from "./pages/aboutUs/ourStory";
import Press from "./pages/aboutUs/press";
import DonateToUs from "./pages/aboutUs/donateToUs";
import OurSupporters from "./pages/aboutUs/ourSupporters";
import Careers from "./pages/aboutUs/careers";
import ContactUs from "./pages/aboutUs/contactUs";
import Endorsements from "./pages/aboutUs/Endorsements";
import TopRated from "./pages/topRated";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Faq from './pages/Faq';
import Dashboard from "./pages/dashboard/index ";
import MyAccountTab from "./pages/myAccountTab";
import PersonalFundraisersDetailsView from "./pages/PersonalFundraisersDetailsView";
import ManageNonprofitNormalUser from "./pages/ManageNonprofitNormalUser";
import ManageDashboard from "./pages/manageDashboard";
import GetBadge from "./pages/getBadge";
import SubmitReview from "./pages/submitReview";
import UserDetailsMyReview from "./pages/userDetailsMyReview";
import CategoryCause from "./pages/categoryCause";
import ReviewPreview from "./pages/getInvolved/reviewPreview";
import ShowcaseReviews from "./pages/forNonprofits/reviews/showCase";
import Nominate from "./pages/review/nominate";
import FaqDetail from "./pages/Faq/faqDetail";
import FaqList from "./pages/Faq/faqList";
import PageNotFound from "./pages/errorPage/pageNotFound";
import ResetPassword from "./pages/login/resetPassword";
import getIPAddress from "./utils/userIpAddress";
import { useDispatch, useSelector } from "react-redux";
import { ipAddressHandler } from "./redux/slices/ipAddress/ipAddressSlice";
import IpAddress from "./pages/ip-Address";
import DonationConfirmation from "./pages/donationConfirm";
import { modulesHandler } from "./redux/slices/ipAddress/modulesSlice";
import VerifyEmail from "./pages/verifyEmail";
import AlphaNonprofits from "./pages/alphaNonprofits";
import Organizations from "./pages/forNonprofits/orgnizations";
import Home from "./pages/home/home";



interface PublicRouteProps {
    Component: React.ComponentType<any>;
    user: any;
    location: any;
}
interface PrivateRouteProps {
    Component: React.ComponentType<any>;
    user: any;
}

const isAuthenticated = () => {
    let token = typeof localStorage !== "undefined" && localStorage.getItem("token");
    if (token) {
        sessionCreated();
        return true;
    }
    return false;
}

const sessionCreated = () => {
    const sessionStartTime = new Date().getTime();
    typeof localStorage !== "undefined" && localStorage.setItem('sessionStartTime', sessionStartTime.toString());
    const timer = setTimeout(() => {
        window.location.reload();
        typeof localStorage !== "undefined" && localStorage.clear();
    }, 24 * 60 * 60 * 1000);
    return () => clearTimeout(timer)
}

const PrivateRoute = ({ Component, user }: PrivateRouteProps) => {
    const token: any = typeof window !== "undefined" && localStorage.getItem("token")
    return token ? <Component /> : <Navigate to="/" />;
    //  return user && isAuthenticated() ? <Component /> : <Navigate to="/" />;
};

const PublicRoute = ({ Component, user, location }: PublicRouteProps) => {
    if (location.pathname.includes("/verify_email")) {
        return <Component />
    }
    return user && isAuthenticated() && (location.pathname === "/signin" || location.pathname === "/signup")
        ? <Navigate to="/" />
        : <Component />;
};

function App() {
    // const [isLoading, setIsLoading] = useState(isServerLoading);
    const [ipAddress, setIpAddress] = useState('');
    const dispatch = useDispatch();
    const [user, setUser] = useState(null);

    // const user = typeof window !== "undefined" ? typeof localStorage !== "undefined" && localStorage.getItem("token") : null;
    const userId = typeof window !== "undefined" ? typeof localStorage !== "undefined" && localStorage.getItem('userId') : null;
    // const user = typeof localStorage !=="undefined"&&localStorage.getItem("token");
    // const userId =  typeof localStorage !=="undefined"&&localStorage.getItem('userId')
    const location = useLocation();
    const navigate = useNavigate()
    const ipAddressStatus = useSelector((state: any) => state?.ipAddress?.data?.results)


    // useEffect(() => {
    //     if (isServerLoading) {
    //         const loadScripts = async () => {
    //             try {
    //                 await new Promise((resolve) => setTimeout(resolve, 1000));
    //                 setIsLoading(false); // Mark loading as complete
    //             } catch (error) {
    //                 console.error("Error loading scripts:", error);
    //             }
    //         };

    //         loadScripts();
    //     }
    // }, [isServerLoading]);



    useEffect(() => {
        // Check for token once the component mounts
        const token: any = typeof window !== "undefined" && localStorage.getItem("token");
        setUser(token);
    }, []);

    useEffect(() => {
        const fetchIPAddress = async () => {
            if (typeof window !== "undefined") {
                const ip = await getIPAddress();
                setIpAddress(ip);
            }
        };

        fetchIPAddress();
        dispatch(modulesHandler() as any)
    }, []);

    useEffect(() => {
        if (ipAddress) {
            const reqBody = {
                ip: ipAddress,
                user_id: userId
            }
            dispatch(ipAddressHandler(reqBody) as any);

        }
    }, [ipAddress])

    useEffect(() => {
        if (ipAddressStatus?.status && ipAddressStatus?.status !== 'unblocked') {
            navigate('/ip-address')
        }
    }, [ipAddressStatus])

    const validPaths = [
        "/organizations/browse",
        "/zipcode",
        "/categories/view",
        "/city",
        "/state"
    ];

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname])

    useEffect(() => {
        const path = location.pathname.split('/').slice(1, 3).join('/');
        const isValidPath = validPaths.some((validPath) => path.startsWith(validPath));

        if (!isValidPath) {
            typeof localStorage !== "undefined" && localStorage.removeItem('category');
            typeof localStorage !== "undefined" && localStorage.removeItem('sort');
        }
    }, [location]);


    return (
        <>

            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                closeButton={false}
                pauseOnHover
            />
            <GlobalStyles />
            {/* {isLoading ? (
                <div style={{ color: "red", height: "50px", width: "50px" }}>
                    <p>Loading...</p>
                </div>
            ) : ( */}
            <>
                {!(location.pathname === "/signin" || location.pathname === "/signup" || location.pathname === "/reset" || location.pathname.includes("/verify_email")) && <Header />}
                <Routes>
                    <Route path="/" element={
                        <PublicRoute user={user} location={location} Component={Home} />

                    } />
                    <Route path="/verify_email/:userId/:token" element={<PublicRoute user={user} location={location} Component={VerifyEmail} />} />
                    <Route path="/signup" element={<PublicRoute user={user} location={location} Component={SignUp} />} />
                    <Route path="/signin" element={<PublicRoute user={user} location={location} Component={Login} />} />
                    <Route path="/reset" element={<PublicRoute user={user} location={location} Component={ResetPassword} />} />
                    <Route path="/ip-address" element={<PublicRoute user={user} location={location} Component={IpAddress} />} />
                    <Route path="/organizations/browse/*" element={<PublicRoute user={user} location={location} Component={SearchPage} />} />
                    <Route path="/zipcode/:zipcode/*" element={<PublicRoute user={user} location={location} Component={SearchPage} />} />
                    <Route path="/categories/view/:categoryName/*" element={<PublicRoute user={user} location={location} Component={SearchPage} />} />
                    <Route path="/city/:cityName/:stateName/*" element={<PublicRoute user={user} location={location} Component={SearchPage} />} />
                    <Route path="/state/:stateName/*" element={<PublicRoute user={user} location={location} Component={SearchPage} />} />
                    <Route path="/near-me/*" element={<PublicRoute user={user} location={location} Component={SearchPage} />} />
                    <Route path="/org/:slug" element={<PublicRoute user={user} location={location} Component={SearchDetails} />} />
                    <Route path="/write-review" element={<PublicRoute user={user} location={location} Component={WriteReview} />} />
                    <Route path="/donate-now" element={<PublicRoute user={user} location={location} Component={DonateNowPage} />} />
                    <Route path="/awards/browse" element={<PublicRoute user={user} location={location} Component={TopRated} />} />
                    <Route path="/detail-award" element={<PublicRoute user={user} location={location} Component={TopRatedAward} />} />
                    <Route path="/explore-cities" element={<PublicRoute user={user} location={location} Component={TopCities} />} />
                    <Route path="/discover-categories-and-causes" element={<PublicRoute user={user} location={location} Component={TopCauses} />} />
                    <Route path="/donations/confirmation/*" element={<PublicRoute user={user} location={location} Component={DonationConfirmation} />} />
                    {/* ------------------------------- Top rated ------------------------------------------ */}
                    <Route path="/toprated/about" element={<PublicRoute user={user} location={location} Component={TopRatedAward} />} />
                    <Route path="/toprated/nominate" element={<PublicRoute user={user} location={location} Component={Nominate} />} />
                    {/* ------------------------------ About pages routing ------------------------------- */}
                    <Route path="/about" element={<PublicRoute user={user} location={location} Component={AboutGreatNonprofit} />} />
                    <Route path="/about/board-members" element={<PublicRoute user={user} location={location} Component={Members} />} />
                    <Route path="/about/advisory-board" element={<PublicRoute user={user} location={location} Component={Members} />} />
                    <Route path="/about/our-story" element={<PublicRoute user={user} location={location} Component={OurStory} />} />
                    <Route path="/about/press" element={<PublicRoute user={user} location={location} Component={Press} />} />
                    <Route path="/about/donate-to-us" element={<PublicRoute user={user} location={location} Component={DonateToUs} />} />
                    <Route path="/about/our-supporters" element={<PublicRoute user={user} location={location} Component={OurSupporters} />} />
                    <Route path="/about/careers" element={<PublicRoute user={user} location={location} Component={Careers} />} />
                    <Route path="/contact-us" element={<PublicRoute user={user} location={location} Component={ContactUs} />} />
                    <Route path="/about/endorsements" element={<PublicRoute user={user} location={location} Component={Endorsements} />} />
                    <Route path="/about/sponsors" element={<PublicRoute user={user} location={location} Component={PartnerSolutions} />} />
                    <Route path="/about/donate-to-nonprofits" element={<PublicRoute user={user} location={location} Component={DonateToNonprofits} />} />
                    <Route path="/about/partner-solutions" element={<PublicRoute user={user} location={location} Component={PartnerSolutions} />} />
                    <Route path="/about/greatnonprofits-api" element={<PublicRoute user={user} location={location} Component={GreatNonprofitsApi} />} />
                    <Route path="/about/link-to-us" element={<PublicRoute user={user} location={location} Component={LinkToUs} />} />
                    <Route path="/about/advertising" element={<PublicRoute user={user} location={location} Component={Advertising} />} />
                    <Route path="/about/get-started" element={<PublicRoute user={user} location={location} Component={GetStarted} />} />
                    <Route path="/about/invite-reviews" element={<PublicRoute user={user} location={location} Component={InviteReviews} />} />
                    <Route path="/about/showcase-reviews" element={<PublicRoute user={user} location={location} Component={ShowcaseReviews} />} />
                    <Route path="/about/greatnonprofits-badge" element={<PublicRoute user={user} location={location} Component={GreatNonprofitsBadge} />} />
                    <Route path="/about/donations" element={<PublicRoute user={user} location={location} Component={Donations} />} />
                    <Route path="/organizations/find" element={<PublicRoute user={user} location={location} Component={Organizations} />} />
                    <Route path="/about/nonprofit-success-stories" element={<PublicRoute user={user} location={location} Component={SuccessStories} />} />
                    <Route path="/about/elliott-advocacy" element={<PublicRoute user={user} location={location} Component={ElliottAdvocacy} />} />
                    <Route path="/about/elliott-advocacy" element={<PublicRoute user={user} location={location} Component={LadyFreethinker} />} />

                    <Route path="/about/giving-guides" element={<PublicRoute user={user} location={location} Component={Guides} />} />
                    <Route path="/about/cities" element={<PublicRoute user={user} location={location} Component={TopCities} />} />
                    <Route path="/about/categories-and-causes" element={<PublicRoute user={user} location={location} Component={TopCauses} />} />

                    <Route path="/support/home" element={<PublicRoute user={user} location={location} Component={Faq} />} />
                    <Route path="/faq-list" element={<PublicRoute user={user} location={location} Component={FaqList} />} />
                    <Route path="/faq-detail" element={<PublicRoute user={user} location={location} Component={FaqDetail} />} />
                    <Route path="/users/*" element={<PublicRoute user={user} Component={MyAccountTab} location={location} />} />
                    <Route path="/personal-fundraisers-details/:id" element={<PublicRoute user={user} location={location} Component={PersonalFundraisersDetailsView} />} />
                    <Route path="/manage-my-nonprofit" element={<PrivateRoute user={user} Component={ManageNonprofitNormalUser} />} />
                    <Route path="/dashboard" element={<PrivateRoute user={user} Component={Dashboard} />} />
                    <Route path="/dashboard/:tab/:id" element={<PrivateRoute user={user} Component={ManageDashboard} />} />
                    <Route path="/get-badge/:id" element={<PublicRoute user={user} location={location} Component={GetBadge} />} />
                    <Route path="/write-review/:id" element={<PublicRoute user={user} location={location} Component={SubmitReview} />} />
                    <Route path="/review/:id" element={<PublicRoute user={user} location={location} Component={ReviewPreview} />} />
                    <Route path="/user/profile/:user_id/*" element={<PublicRoute user={user} location={location} Component={UserDetailsMyReview} />} />
                    <Route path="/category-cause" element={<PublicRoute user={user} location={location} Component={CategoryCause} />} />
                    <Route path="/navigation/:key" element={<PublicRoute user={user} location={location} Component={CategoryCause} />} />
                    <Route path="/nonprofits/:alpha/:page" element={<PublicRoute user={user} location={location} Component={AlphaNonprofits} />} />

                    <Route path="*" element={<PublicRoute user={user} location={location} Component={PageNotFound} />} />
                </Routes>
                {!(location.pathname === "/signin" || location.pathname === "/signup" || location.pathname === "/reset" || location.pathname === "/ip-address" || location.pathname.includes("/verify_email")) && <Footer />}
            </>
            {/* )
            } */}
        </>
    );
}
export default App;